import React from 'react';
import { Link as MuiLink } from '@mui/material';

const LessonBreadcrumbs = ({
  text,
  queryParams,
  userId,
  skipPhone,
  passingSearch,
  url,
}) => {
  if (text) {
    return (
      <MuiLink
        style={{
          fontSize: '0.875rem',
          fontWeight: 400,
          fontFamily: 'Montserrat',
          letterSpacing: '0.25px',
        }}
        underline="hover"
        color="inherit"
        href={`${process.env.GATSBY_APP_BASE_URL}${
          url || '/'
        }?${queryParams}&utm_origin=SEO&SEOID=${userId}${skipPhone}${passingSearch}`}
      >
        {text}
      </MuiLink>
    );
  } else {
    return null;
  }
};

export default LessonBreadcrumbs;
